// extracted by mini-css-extract-plugin
module.exports = {"resultsAccordion":"styles_resultsAccordion__YG5I3","resultsAccordionTitle":"styles_resultsAccordionTitle__1Miaw","slideInFromRight":"styles_slideInFromRight__3fYUD"};